import { useState } from "react";

export default function ReadMore({
  text,
  excerptLength = 200,
}: {
  text: string;
  excerptLength?: number;
}) {
  const isExpandable = text.length >= excerptLength;
  const excerpt = text.slice(0, excerptLength) + "...";
  const [isExpanded, setIsExpanded] = useState(false);
  const cls = "whitespace-pre-line break-words";

  if (!isExpandable) {
    return <p className={cls}>{text}</p>;
  }

  if (isExpanded) {
    return (
      <p className={cls}>
        {text}{" "}
        <button className="text-secondary" onClick={() => setIsExpanded(false)}>
          Läs mindre
        </button>
      </p>
    );
  }

  return (
    <p className={cls}>
      {excerpt}{" "}
      <button className="text-secondary" onClick={() => setIsExpanded(true)}>
        Läs mer
      </button>
    </p>
  );
}
